module.exports = __webpack_public_path__ + "img/04_tu.e33488a4.png";